<template>
  <div>
    <el-card>
      <el-page-header
        :content="pageInfo.normType + '考核人员列表'"
        @back="goBack"
      />
      <div class="text-group">
        <p>考核周期: {{ pageInfo.year }}年，{{ pageInfo.season }}</p>
      </div>
      <el-table
        :data="personalEvaList"
        style="width: 100%"
        height="600"
        :default-sort="{ prop: 'id' }"
        row-key="id"
      >
        <template v-for="column in personalEvaListTable" :key="column.label">
          <el-table-column :prop="column.prop" :label="column.label">
          </el-table-column>
        </template>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button
              size="mini"
              @click="handleEva(scope.$index, scope.row)"
              type="text"
              >评分</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 个性指标考评扣分表格 -->
    <el-dialog
      v-model="showableComp.showPersonalEvaTable"
      width="90%"
      :title="personalEvaForm.title"
    >
      <el-divider></el-divider>
      <p style="text-align: start">考评对象信息</p>
      <el-form>
        <el-row gutter="80">
          <el-col :span="8">
            <el-form-item label="考核对象姓名">
              <el-input v-model="personalEvaForm.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属科室">
              <el-input
                v-model="personalEvaForm.departmentName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职务/职级">
              <el-input v-model="personalEvaForm.position" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <p style="text-align: start">考评内容</p>
      <el-table
        :data="personalEvaForm.taskList"
        border
        style="width: 100%"
        height="600"
      >
        <template v-for="column in taskEvaTable" :key="column.label">
          <el-table-column
            show-overflow-tooltip
            :prop="column.prop"
            :label="column.label"
            width="180"
            :formatter="formatter"
          >
          </el-table-column>
        </template>

        <el-table-column
          prop="subScore"
          label="扣分值"
          width="180"
          fixed="right"
        >
          <template #default="scope">
            <el-input
              v-model="scope.row.subScore"
              v-on:input="change(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注" width="180" fixed="right">
          <template #default="scope">
            <el-input
              v-model="scope.row.remarks"
              v-on:input="change(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-form class="total">
        <el-row gutter="40">
          <el-col :span="6">
            <el-form-item label="标准分值">
              <el-input v-model="personalEvaForm.lastScore" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="个性指标扣分">
              <el-input v-model="personalEvaForm.subScore" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="总体扣分">
              <el-input
                v-model="personalEvaForm.totalSubScore"
                :disabled="disableComp.subScoreBtn"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="最终得分">
              <el-input v-model="personalEvaForm.score"></el-input>
            </el-form-item>
          </el-col>
          <el-divider></el-divider>
        </el-row>
      </el-form>

      <p style="text-align: start">附件</p>
      <div class="appendix-group">
        <template v-for="item in personalEvaForm.appendixList" :key="item.url">
          <div class="appendix">
            <el-button
              type="text"
              size="small"
              @click="downloadFile(item.url)"
              >{{ item.name }}</el-button
            >
          </div>
        </template>
      </div>

      <div class="btn-group">
        <el-popconfirm
          title="确认提交?（提交后不可修改）"
          @confirm="saveEva"
          confirm-button-text="是"
          cancel-button-text="否"
        >
          <template #reference>
            <el-button type="primary" :disabled="disableComp.submit"
              >提交</el-button
            >
            <el-button @click="doCancel">取消</el-button>
          </template>
        </el-popconfirm>
        <!-- <el-button
          type="primary"
          @click="saveEva"
          :disabled="disableComp.submit"
          >提交</el-button
        >
        <el-button @click="doCancel">取消</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PersonalEva from "../api/PersonalEva";
export default PersonalEva;
</script>

<style scoped lang="scss">
.text-group {
  display: flex;
  justify-content: start;
  color: gray;
  font-size: 14px;
}

.el-divider {
  margin-top: 0px;
}

.appendix {
  display: flex;
  justify-content: start;
}

.btn-group {
  display: flex;
  justify-content: end;
}

.total {
  margin-top: 20px;
}
</style>